import { head, last } from '@antv/util';
import { Region } from '../../../interface';
import MaskBase from './base';

/**
 * @ignore
 * ç©å½¢çè¾å©æ¡ Action
 */
class RectMask extends MaskBase {
  protected shapeType = 'rect';
  protected getRegion(): Region {
    const points = this.points;
    return {
      start: head(points),
      end: last(points),
    };
  }
  // æ·»å å¾å½¢
  protected getMaskAttrs() {
    const { start, end } = this.getRegion();
    const x = Math.min(start.x, end.x);
    const y = Math.min(start.y, end.y);
    const width = Math.abs(end.x - start.x);
    const height = Math.abs(end.y - start.y);
    return {
      x,
      y,
      width,
      height,
    };
  }
}

export default RectMask;
